import { render, staticRenderFns } from "./pronunciationAddPage.vue?vue&type=template&id=5ecdf4ea&scoped=true&"
import script from "./pronunciationAddPage.vue?vue&type=script&lang=js&"
export * from "./pronunciationAddPage.vue?vue&type=script&lang=js&"
import style0 from "./pronunciationAddPage.vue?vue&type=style&index=0&id=5ecdf4ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecdf4ea",
  null
  
)

export default component.exports